import React from 'react';
import { IntlProvider } from 'react-intl';
import { BrowserRouter, Route } from 'react-router-dom';
import { string } from 'prop-types';
import TranslationMessageProvider from '@hmhco/i18n-react/src/TranslationsMessageProvider';
import ctsDefaultTheme from '@hmhco/cts-default-theme';
import TopLevelThemeProvider from '@hmhco/toplevel-theme-provider';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PLATFORM_THEMES } from '@hmhco/platform-helper';
import { identifyPlatform } from '@hmhco/login-config';
import ErrorBoundary from './components/ErrorBoundaryComponent';
import { defaultTranslations, getLocaleFile } from './lang';
import rootReducer from './store/reducers';
import TenantPickerRoutes from './components/TenantPickerRoutes';

export const store = createStore(rootReducer);

const queryClient = new QueryClient();

const App = ({ languageKey }) => {
  const platform = identifyPlatform();

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter basename="/ui/login/">
            <TranslationMessageProvider
              locale={languageKey}
              messageFetchFunction={getLocaleFile}
              defaultTranslations={defaultTranslations}
            >
              {messages => (
                <IntlProvider locale={languageKey} messages={messages}>
                  <TopLevelThemeProvider
                    theme={PLATFORM_THEMES[platform] || ctsDefaultTheme}
                  >
                    <Route
                      path="/"
                      render={({ match }) => (
                        <TenantPickerRoutes
                          url={match.url}
                          configuration={platform}
                        />
                      )}
                    />
                  </TopLevelThemeProvider>
                </IntlProvider>
              )}
            </TranslationMessageProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </Provider>
    </ErrorBoundary>
  );
};

App.propTypes = {
  languageKey: string,
};

App.defaultProps = {
  languageKey: 'en-US',
};

export default App;
